module.exports = __webpack_public_path__ + "static/url-edit-bd0e10249d7ca2152e96e4cfaf3b7873.png";